export default __webpack_public_path__ + "static/media/84t.f0d28968.jpg";